import React, { useState } from 'react';
import { depositAmount } from "../../../api/user";
import { useUserStore } from '../../../store/user_store';

import bankCard from '../../../dist/icons/bank-card.svg';
import wallet from '../../../dist/icons/electronic-card.svg';

const WalletsPage = () => {
    const user = useUserStore(state => state.user);

    const [amount, setAmount] = useState('');
    const [isModal, setModal] = useState(false);
    const [depositType, setDepositType] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    const closeModal = () => {
        setModal(false);
        setAmount('');
        setDepositType(null);
    }

    const deposit = async () => {
        if (amount > 0 && amount !== '') {
            setIsProcessing(true);
            try {
                const data = await depositAmount({
                    amount: amount,
                    success_url: 'https://rekpark.kg/complete',
                    payment_method: depositType
                });
                if (data.redirect_url != null) {
                    window.location.href = data.redirect_url;
                }
            } catch (error) {
                console.error('Deposit error:', error);
            }
            setIsProcessing(false);
        }
    }

    const openModal = (type) => {
        setModal(true);
        setDepositType(type);
    }

    const getDepositLabel = () => {
        if (depositType === 'bankcard') return 'Банковской картой';
        if (depositType === 'wallet') return 'Электронным кошельком';
        return '';
    };

    return (
        <>
            <div className="px-2 sm:px-0">
                {/* User Balance Card */}
                <div className="bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 rounded-2xl p-5 sm:p-6 text-white relative overflow-hidden">
                    <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0iYSIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBwYXR0ZXJuVHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cmVjdCB3aWR0aD0iMSIgaGVpZ2h0PSI0MCIgZmlsbD0icmdiYSgyNTUsMjU1LDI1NSwwLjA1KSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3QgZmlsbD0idXJsKCNhKSIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIvPjwvc3ZnPg==')] opacity-50" />
                    <div className="relative z-10 flex items-center gap-4">
                        <img
                            className="w-14 h-14 sm:w-16 sm:h-16 rounded-full object-cover ring-2 ring-white/30 shadow-lg"
                            src={user?.image}
                            alt=""
                        />
                        <div className="flex-1 min-w-0">
                            <p className="text-white/70 text-xs font-medium uppercase tracking-wider">Ваш баланс</p>
                            <p className="text-2xl sm:text-3xl font-bold mt-0.5">{user?.balance || 0} <span className="text-lg font-medium text-white/80">сом</span></p>
                            <p className="text-white/60 text-xs mt-1 truncate">{user?.name} • {user?.email}</p>
                        </div>
                    </div>
                </div>

                {/* Payment Methods */}
                <div className="mt-6 sm:mt-8">
                    <h2 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
                        <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                        </svg>
                        Способ оплаты
                    </h2>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                        {/* Bank Card */}
                        <button
                            onClick={() => openModal('bankcard')}
                            className="group relative overflow-hidden rounded-2xl p-5 sm:p-6 text-left transition-all duration-300 hover:shadow-xl active:scale-[0.98] bg-gradient-to-br from-cyan-400 to-blue-500 shadow-lg shadow-blue-500/20"
                        >
                            <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2 group-hover:scale-150 transition-transform duration-500" />
                            <div className="relative z-10 flex items-center gap-4">
                                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                                    <img src={bankCard} alt="" className="w-7 h-7 sm:w-8 sm:h-8" />
                                </div>
                                <div>
                                    <h3 className="text-white font-bold text-base sm:text-lg">Банковской картой</h3>
                                    <p className="text-white/70 text-xs mt-0.5">Visa, MasterCard, Элкарт</p>
                                </div>
                            </div>
                        </button>

                        {/* Electronic Wallet */}
                        <button
                            onClick={() => openModal('wallet')}
                            className="group relative overflow-hidden rounded-2xl p-5 sm:p-6 text-left transition-all duration-300 hover:shadow-xl active:scale-[0.98] bg-gradient-to-br from-purple-500 to-fuchsia-500 shadow-lg shadow-purple-500/20"
                        >
                            <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2 group-hover:scale-150 transition-transform duration-500" />
                            <div className="relative z-10 flex items-center gap-4">
                                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                                    <img src={wallet} alt="" className="w-7 h-7 sm:w-8 sm:h-8" />
                                </div>
                                <div>
                                    <h3 className="text-white font-bold text-base sm:text-lg">Электронные кошельки</h3>
                                    <p className="text-white/70 text-xs mt-0.5">Balance, MegaPay, O!Деньги</p>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
            </div>

            {/* Custom Modal — replaces Ant Design Modal */}
            {isModal && (
                <div className="fixed inset-0 z-[9999] flex items-end sm:items-center justify-center">
                    {/* Backdrop */}
                    <div
                        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
                        onClick={closeModal}
                        style={{ animation: 'fadeIn 0.2s ease' }}
                    />
                    {/* Modal Content */}
                    <div
                        className="relative w-full sm:max-w-md mx-auto bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl overflow-hidden"
                        style={{ animation: 'slideUp 0.3s ease' }}
                    >
                        {/* Drag Handle (mobile) */}
                        <div className="sm:hidden flex justify-center pt-3">
                            <div className="w-10 h-1 bg-slate-200 rounded-full" />
                        </div>

                        {/* Modal Header */}
                        <div className="px-5 sm:px-6 pt-4 pb-3 flex items-center justify-between">
                            <div className="flex items-center gap-3">
                                <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                                    depositType === 'bankcard'
                                        ? 'bg-gradient-to-br from-cyan-400 to-blue-500'
                                        : 'bg-gradient-to-br from-purple-500 to-fuchsia-500'
                                }`}>
                                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <div>
                                    <h3 className="text-lg font-bold text-slate-800">Пополнение счёта</h3>
                                    <p className="text-xs text-slate-400">{getDepositLabel()}</p>
                                </div>
                            </div>
                            <button
                                onClick={closeModal}
                                className="w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition-colors"
                            >
                                <svg className="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        {/* Modal Body */}
                        <div className="px-5 sm:px-6 pb-6 pt-2">
                            {/* Info Alert */}
                            <div className="bg-blue-50 border border-blue-100 rounded-xl p-3 mb-4 flex items-start gap-2.5">
                                <svg className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <p className="text-sm text-blue-700">Введите сумму пополнения в сомах</p>
                            </div>

                            {/* Current Balance */}
                            <div className="bg-slate-50 rounded-xl p-3 mb-4 flex items-center justify-between">
                                <span className="text-sm text-slate-500">Текущий баланс</span>
                                <span className="text-base font-bold text-slate-800">{user?.balance || 0} сом</span>
                            </div>

                            {/* Amount Input */}
                            <div className="space-y-1.5 mb-4">
                                <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Сумма</label>
                                <div className="relative">
                                    <input
                                        value={amount}
                                        type="number"
                                        inputMode="numeric"
                                        placeholder="Введите сумму"
                                        className="w-full px-4 py-3.5 bg-white border border-slate-200 rounded-xl text-lg font-semibold text-slate-700 placeholder-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-400 transition-all duration-200"
                                        onChange={(e) => setAmount(e.target.value)}
                                        autoFocus
                                    />
                                    <span className="absolute right-4 top-1/2 -translate-y-1/2 text-sm font-medium text-slate-400">сом</span>
                                </div>
                            </div>

                            {/* Quick Amount Buttons */}
                            <div className="flex gap-2 mb-5">
                                {[100, 500, 1000, 5000].map((val) => (
                                    <button
                                        key={val}
                                        onClick={() => setAmount(val)}
                                        className={`flex-1 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                                            parseInt(amount) === val
                                                ? 'bg-blue-500 text-white shadow-md shadow-blue-500/20'
                                                : 'bg-slate-100 text-slate-600 hover:bg-slate-200 active:scale-95'
                                        }`}
                                    >
                                        {val}
                                    </button>
                                ))}
                            </div>

                            {/* Action Buttons */}
                            <div className="flex gap-3">
                                <button
                                    onClick={closeModal}
                                    className="flex-1 py-3.5 bg-slate-100 text-slate-600 font-medium text-sm rounded-xl hover:bg-slate-200 transition-all duration-200 active:scale-[0.98]"
                                >
                                    Отмена
                                </button>
                                <button
                                    onClick={deposit}
                                    disabled={!amount || amount <= 0 || isProcessing}
                                    className="flex-[2] py-3.5 bg-gradient-to-r from-blue-600 to-blue-500 text-white font-semibold text-sm rounded-xl shadow-lg shadow-blue-500/25 hover:from-blue-700 hover:to-blue-600 transition-all duration-200 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                                >
                                    {isProcessing ? (
                                        <>
                                            <svg className="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                            </svg>
                                            Обработка...
                                        </>
                                    ) : (
                                        <>
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
                                            </svg>
                                            Пополнить
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default WalletsPage;